import { Button, Text } from '@fluentui/react-components'
import { ErrorCircle48Regular, Home24Regular } from '@fluentui/react-icons'
import { useNavigate } from 'react-router-dom'
import { usePageNotFoundStyles } from './PageNotFound.style'

export function PageNotFound() {
  const styles = usePageNotFoundStyles()
  const navigate = useNavigate()

  return (
    <div className={styles.root}>
      <div className={styles.headerRow}>
        <ErrorCircle48Regular className={styles.errorIcon} aria-hidden="true" />
        <Text as="h1" size={900} weight="bold">
          404
        </Text>
      </div>
      <Text as="h2" size={600} weight="semibold">
        Page Not Found !!
      </Text>
      <Text size={400} className={styles.subText}>
        Sorry, the page you are looking for doesn&apos;t exist or has been moved.
      </Text>
      <Button
        appearance="secondary"
        icon={<Home24Regular />}
        size="large"
        onClick={() => navigate('/')}
      >
        Go to Home
      </Button>
    </div>
  )
}
